import React from 'react';
import './TeamSection.css';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'R.K. BHATIA',
      role: 'Founding Partner',
      description: 'Mr. R.K. Bhatia is a graduate in Mechanical Engineering and post graduation in Business Management. He has more than 45 years of Industrial experience, starting his career with companies like Larsen & Toubro and Voltas. He manages operations and finances for the group companies.',
      experience: '45+ Years'
    },
    {
      name: 'ABHAY BHATIA',
      role: 'Partner',
      description: 'Abhay graduated in Computer Engineering in 2007, following which he worked in various roles at John Galt. In 2013, he completed his MBA in General Management and Marketing from the Indian School of Business. Since then, Abhay heads sales, marketing and strategy.',
      experience: '15+ Years'
    }
  ];

  return (
    <section className="section team-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Meet Our Leadership Team</h2>
          <p className="section-subtitle">
            Experienced professionals driving innovation and excellence
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-image">
                <div className="team-placeholder">
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span className="team-initial">{member.name.charAt(0)}</span>
                </div>
                <div className="experience-badge">
                  <span>{member.experience}</span>
                </div>
              </div>

              <div className="team-content">
                <h3 className="team-name">{member.name}</h3>
                <div className="team-role">
                  <span className="role-badge">{member.role}</span>
                </div>
                <p className="team-description">{member.description}</p>

                <div className="team-social">
                  <a href="/" className="social-link" aria-label="LinkedIn">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                      <rect x="2" y="9" width="4" height="12"></rect>
                      <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                  </a>
                  <a href="/" className="social-link" aria-label="Email">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
